module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Altri_Pericoli.4a780363.svg";